<div class="text-danger" i18n>Только для загрузки изображений</div>
<p class="f11" i18n>
  Мы ожидаем, что вы приложите скриншот (снимок экрана).
</p>

<div class="my16">
  <input type="file"
         accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp, image/webp"
         [formControl]="$any(field.formControl)"
         [formlyAttributes]="field"
         multiple
         (change)="onChange($event)">
</div>

<img *ngFor="let item of result" [src]="item" alt="preview">
